import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MotiveDesktop from './desktop/MotiveDesktop';
import MotiveMobile from './mobile/MotiveMobile';
import FormList from './forms/desktop/FormList';
import { Box } from '@material-ui/core';

const MotiveList = ({ ...props }) => {
  const { motives, mobile, product } = props;
  const [openMotive, setOpenMotive] = useState(0);

  const activeMotives = motives.filter((motive) => motive.visible === 'on');

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {activeMotives.map((motive, index) => (
        <React.Fragment key={index}>
          {mobile ? (
            <MotiveMobile
              title={motive.title}
              motiveId={motive.id}
              type={motive.type}
              product={product}
            />
          ) : (
            <MotiveDesktop
              title={motive.title}
              type={motive.type}
              motiveId={motive.id}
              openMotive={openMotive}
              setOpenMotive={setOpenMotive}
              haveValidation={motive.haveValidation}
            >
              <FormList
                motiveId={motive.id}
                type={motive.type}
                mobile={mobile}
                product={product}
                data-cy={`desktopMotive-${index}`}
              />
            </MotiveDesktop>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

MotiveList.propTypes = {
  motives: PropTypes.array,
  mobile: PropTypes.bool,
  product: PropTypes.object,
};

export default MotiveList;
